import { render } from "./front-imagen-cover.vue?vue&type=template&id=aa8db0d8"
import script from "./front-imagen-cover.vue?vue&type=script&lang=js"
export * from "./front-imagen-cover.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__